import {userSession} from "../observers/userObserver"

class ApiService {
    constructor(baseUrl) {
        // remove / from the end of the url
        this.baseUrl = baseUrl;
    }

    async request(endpoint, method = 'GET', data = null, useToken = false, headers = {}, retires = 3) {
        const url = `${this.baseUrl}${endpoint}`;
        const token = useToken ? userSession.getToken() : null;
        

        const options = {
            method,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : undefined,
                ...headers
            }
        }

        if (data) {
            options.body = JSON.stringify(data);
        }

        for (let i = 0; i < retires; i++) {
            try {
                const response = await fetch(url, options);
                const responseData = await response.json();

                if (response.status === 401) {
                    await userSession.refreshToken();
                    continue;
                }

                if (response.ok) {
                    return { ok: response.ok, status: response.status, data: responseData };
                } else if (response.status >= 500){
                    console.error(`Failed to fetch ${endpoint}:`, responseData, "retrying...");
                    if (i === retires - 1) {
                        return { ok: response.ok, status: response.status, data: responseData };
                    }
                } else {
                    return { ok: response.ok, status: response.status, data: responseData };
                }
            } catch (error) {
                console.error(`Error fetching ${endpoint}:`, error);
                if (i === retires - 1) {
                    throw error;
                }
            }
        }
    }

    get(endpoint, useToken = false, headers = {}, retires = 3) {
        return this.request(endpoint, 'GET', null, useToken, headers, retires);
    }

    post(endpoint, data, useToken = false, headers = {}, retires = 3) {
        return this.request(endpoint, 'POST', data, useToken, headers, retires);
    }

    put(endpoint, data, useToken = false, headers = {}, retires = 3) {
        return this.request(endpoint, 'PUT', data, useToken, headers, retires);
    }

    delete(endpoint, useToken = false, headers = {}, retires = 3) {
        return this.request(endpoint, 'DELETE', null, useToken, headers, retires);
    }
};

export default ApiService;